<template>
<div class="chapter">
<div class="inner_page">
<img src="02-chapter01.html.jpg" style="margin-right: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02-chapter01.vue?140f6d70